import { computed } from 'vue'

import { storeToRefs } from 'pinia'

import { useEventsDirectorySearchStore } from '../stores/events-directory-search.ui-store'
import type { UseEventsDirectorySearch } from '../types/events-directory-search'
import type { EventsHubCard } from '../types/events-hub'

/**
 * Component-facing API for the shared events directory search state.
 *
 * Wraps the Pinia UI store so components depend on the composable boundary
 * (Component → Composable → Store) instead of importing the store directly.
 */
export function useEventsDirectorySearch(): UseEventsDirectorySearch {
  const store = useEventsDirectorySearchStore()
  const { searchQuery } = storeToRefs(store)

  const needle = computed(() => searchQuery.value.trim().toLowerCase())
  const isSearchActive = computed(() => needle.value.length > 0)

  const filterEvents = (events: readonly EventsHubCard[]): readonly EventsHubCard[] => {
    if (!isSearchActive.value) return events
    return events.filter(event =>
      [event.title, event.locationLabel, event.dateLabel].some(value => value.toLowerCase().includes(needle.value))
    )
  }

  return {
    searchQuery,
    isSearchActive,
    setSearchQuery: store.setSearchQuery,
    filterEvents,
    reset: store.reset,
  }
}
